<template lang="pug">
  app-modal(
    :titulo="isEditing ? 'Editar Assinatura' : 'Adicionar Assinatura'",
    :width=1600,
    :height=1000,
    @closeModal="$emit('closeModal')",
    :closeOutside="false"
  )
    template(slot="body")
      div
        el-row(v-if="!isEditing" type="flex" align="middle" class="input-row")
          input(
            ref="fileInput"
            type="file"
            accept="application/pdf,image/png,image/jpeg,image/jpg,image/webp"
            class="hidden-input"
            @change="onPickFile"
          )

          el-input(
            v-model="fileName"
            placeholder="Selecione um arquivo PDF ou imagem"
            readonly
            class="flex-1"
          )

          el-button(
            icon="el-icon-upload"
            @click="openFileDialog"
            class="bt-buscar-arquivo"
          ) Buscar arquivo

        el-row(:gutter="16" class="mt-16")
          el-col(:span="12")
            el-card(shadow="never")
              div(v-if="!isEditing" class="btn-group")
                el-button(
                  @click="initCropper"
                  :disabled="!renderedDataUrl || !!cropper"
                ) Ativar recorte
                el-button(
                  type="primary"
                  @click="doCrop"
                  :disabled="!cropper"
                ) Recortar
                el-button(
                  type="danger"
                  @click="destroyCropper"
                  :disabled="!cropper"
                ) Cancelar

              div(v-if="croppedDataUrl" class="mt-24 container-card")
                div(class="input-row")
                  el-col(:span="12" class="input-col")
                    span Nome para a assinatura:
                    el-input(
                      v-model="nomeAssinatura"
                      placeholder="Nome"
                      @input="nomeAssinatura = $event.toUpperCase()"
                    )
                  el-col(:span="12" class="input-col")
                    span Cargo:
                    el-input(
                      v-model="cargoAssinatura"
                      placeholder="Cargo"
                    )
                div(class="input-row")
                  el-col(:span="12" class="input-col")
                    span Tamanho fonte do nome:
                    el-input-number(
                      v-model="modelNameFontSize"
                      :min="1"
                      :max="300"
                      :step="1"
                      controls-position="right"
                      class="num-only"
                    )
                  el-col(:span="12" class="input-col")
                    span Tamanho fonte do cargo:
                    el-input-number(
                      v-model="modelCargoFontSize"
                      :min="1"
                      :max="300"
                      :step="1"
                      controls-position="right"
                      class="num-only"
                    )
                  el-col(:span="12" class="input-col")
                    span Espessura da linha:
                    el-input-number(
                      v-model="modelLineWidth"
                      :min="1"
                      :max="300"
                      :step="1"
                      controls-position="right"
                      class="num-only"
                    )
                div(class="input-row")
                  el-col(:span="12" class="input-col")
                    span Espaço acima da linha:
                    el-input-number(
                      v-model="modelLineGapTop"
                      :min="-100"
                      :max="300"
                      :step="1"
                      controls-position="right"
                      class="num-only"
                    )
                  el-col(:span="12" class="input-col")
                    span Espaço abaixo da linha:
                    el-input-number(
                      v-model="modelLineGapBottom"
                      :min="1"
                      :max="300"
                      :step="1"
                      controls-position="right"
                      class="num-only"
                    )
                  el-col(:span="12" class="input-col")
                    span Espaço entre nome e cargo:
                    el-input-number(
                      v-model="modelTextGap"
                      :min="1"
                      :max="300"
                      :step="1"
                      controls-position="right"
                      class="num-only"
                    )
            el-card(shadow="never" v-if="renderedDataUrl && isCropped" class="mt-16")
              div(class="input-row")
                el-tooltip(content="Use o mouse ou as setas do teclado" placement="top")
                  div(class="input-col")
                    span Rotação: {{ rotationAngle }}°
                    input(
                      type="range"
                      v-model.number="rotationAngle"
                      min="-180"
                      max="180"
                      step="1"
                      class="native-slider"
                      @input="applyRotation"
                    )
                el-tooltip(content="Resetar rotação" placement="top")
                  el-button(
                    circle
                    icon="el-icon-refresh"
                    @click="resetRotation"
                    class="reset-rotation-btn"
                    :disabled="rotationAngle === 0"
                  )
                el-tooltip(content="Excluir arquivo" placement="top")
                  el-button(
                    icon="el-icon-delete"
                    circle
                    @click="deleteFile"
                  )
              img(
                ref="img"
                :src="renderedDataUrl"
                class="pdf-image"
              )
          el-col(:span="12" v-if="isEditing || isCropped")
            el-card(shadow="never")
              h4(class="preview-title") Prévia da assinatura

              div(
                v-if="finalBlobUrl"
                class="preview-container"
              )
                img(
                  :src="finalBlobUrl"
                  class="preview-image"
                )
              div(
                v-if="finalBlobUrl"
                class="footer-actions"
              )
                el-button(
                  @click="$emit('closeModal')"
                ) Cancelar

                div(class="actions-right")
                  el-button(
                    type="primary"
                    icon="el-icon-check"
                    @click="uploadToBackend"
                  ) Salvar Assinatura
          el-col(:span="12" v-if="!isEditing && !isCropped")
            el-card(shadow="never" v-if="renderedDataUrl")
              div(class="input-row")
                el-tooltip(content="Use o mouse ou as setas do teclado" placement="top")
                  div(class="input-col")
                    span Rotação: {{ rotationAngle }}°
                    input(
                      type="range"
                      v-model.number="rotationAngle"
                      min="-180"
                      max="180"
                      step="1"
                      class="native-slider"
                      @input="applyRotation"
                    )
                el-tooltip(content="Resetar rotação" placement="top")
                  el-button(
                    circle
                    icon="el-icon-refresh"
                    @click="resetRotation"
                    class="reset-rotation-btn"
                    :disabled="rotationAngle === 0"
                  )
                el-tooltip(content="Excluir arquivo" placement="top")
                  el-button(
                    icon="el-icon-delete"
                    circle
                    @click="deleteFile"
                  )
              img(
                ref="img"
                :src="renderedDataUrl"
                class="pdf-image"
              )
            div(v-else class="empty-state")
              i(class="el-icon-document empty-icon")
              span Selecione um arquivo PDF ou imagem para extrair a assinatura
</template>

<script>
import { mapActions } from 'vuex'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppModal from '@/components/AppModal'
import * as pdfjsLib from 'pdfjs-dist/build/pdf'
import pdfWorker from 'pdfjs-dist/build/pdf.worker.entry'
import Cropper from 'cropperjs'
import axios from '@/utils/api'
import 'cropperjs/dist/cropper.css'
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorker

export default {
  name: 'AppModalAdicionarAssinatura',

  props: {
    assinaturaEditando: {
      type: Object,
      default: null
    }
  },

  components: {
    AppModal
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      fileName: '',
      renderedDataUrl: null,
      croppedDataUrl: null,
      finalBlobUrl: null,
      finalBlob: null,
      cropper: null,
      nomeAssinatura: '',
      cargoAssinatura: '',
      modelLineGapTop: 2,
      modelLineGapBottom: 10,
      modelLineWidth: 2,
      modelNameFontSize: 50,
      modelCargoFontSize: 20,
      modelTextGap: 6,
      isEditing: false,
      isCropped: false,
      rotationAngle: 0,
      originalDataUrl: null
    }
  },

  mounted () {
    window.addEventListener('paste', this.handlePaste)
    this.initValuesForEdit()
  },

  methods: {
    ...mapActions({
      save: 'assinaturaPdf/save'
    }),
    handleUppercase (value) {
      this.nomeAssinatura = value.toUpperCase()
    },
    openFileDialog () {
      this.$refs.fileInput.click()
    },
    initValuesForEdit () {
      if (!this.assinaturaEditando) return

      this.isEditing = true
      this.nomeAssinatura = this.assinaturaEditando.nome
      this.cargoAssinatura = this.assinaturaEditando.cargo
      this.modelLineGapTop = this.assinaturaEditando.espacoAssinaturaLinha
      this.modelLineGapBottom = this.assinaturaEditando.espacoLinhaCargo
      this.modelLineWidth = this.assinaturaEditando.espessuraLinha
      this.modelNameFontSize = this.assinaturaEditando.tamanhoFonteNome
      this.modelCargoFontSize = this.assinaturaEditando.tamanhoFonteCargo

      if (this.assinaturaEditando.preview) {
        this.loadImageFromDocument(this.assinaturaEditando.preview)
      }
    },
    async loadImageFromDocument (document) {
      try {
        const blob = await axios({
          method: 'POST',
          url: `documento/file`,
          data: document,
          responseType: 'blob'
        })
        const reader = new FileReader()
        reader.onload = async (ev) => {
          this.croppedDataUrl = ev.target.result
          await this.$nextTick()
          await new Promise(resolve => setTimeout(resolve, 100))
          this.buildFinalImage()
        }
        reader.readAsDataURL(blob)
      } catch (error) {
        console.error('Erro ao carregar imagem:', error)
        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERRO,
          'Erro ao carregar preview da assinatura'
        )
      }
    },
    async applyRotation () {
      if (!this.originalDataUrl) return

      const img = await this.loadImage(this.originalDataUrl)
      const angle = this.rotationAngle
      const radians = angle * Math.PI / 180

      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')

      const sin = Math.abs(Math.sin(radians))
      const cos = Math.abs(Math.cos(radians))
      canvas.width = Math.round(img.width * cos + img.height * sin)
      canvas.height = Math.round(img.width * sin + img.height * cos)

      ctx.translate(canvas.width / 2, canvas.height / 2)
      ctx.rotate(radians)
      ctx.drawImage(img, -img.width / 2, -img.height / 2)

      this.renderedDataUrl = canvas.toDataURL('image/png')
      this.destroyCropper()
    },
    resetRotation () {
      this.rotationAngle = 0
      if (this.originalDataUrl) {
        this.renderedDataUrl = this.originalDataUrl
        this.destroyCropper()
      }
    },
    deleteFile () {
      this.renderedDataUrl = null
      this.fileName = ''
    },
    async handlePaste (event) {
      const items = event.clipboardData?.items
      if (!items || this.isEditing) return

      for (const item of items) {
        if (item.type.startsWith('image/')) {
          const file = item.getAsFile()

          if (!file) return

          this.fileName = 'imagem_colada.png'
          this.resetAll()

          const reader = new FileReader()
          reader.onload = (ev) => {
            this.renderedDataUrl = ev.target.result
            this.originalDataUrl = ev.target.result
          }

          reader.readAsDataURL(file)

          break
        }
      }
    },
    async onPickFile (e) {
      const file = e.target.files?.[0]
      if (!file) return

      this.fileName = file.name
      this.resetAll()

      const isImage = file.type.startsWith('image/')
      const isPdf = file.type === 'application/pdf'

      if (isImage) {
        const reader = new FileReader()
        reader.onload = (ev) => {
          this.renderedDataUrl = ev.target.result
          this.originalDataUrl = this.renderedDataUrl
        }
        reader.readAsDataURL(file)
      } else if (isPdf) {
        const buf = await file.arrayBuffer()
        const pdf = await pdfjsLib.getDocument({ data: buf }).promise
        const page = await pdf.getPage(1)

        const scale = 2.5
        const viewport = page.getViewport({ scale })

        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')
        canvas.width = viewport.width
        canvas.height = viewport.height

        await page.render({ canvasContext: ctx, viewport }).promise
        this.renderedDataUrl = canvas.toDataURL('image/png')
        this.originalDataUrl = this.renderedDataUrl
      } else {
        this.$message.warning('Formato não suportado. Use PDF, PNG, JPG ou WEBP.')
      }
      this.rotationAngle = 0
    },

    initCropper () {
      if (this.cropper) return
      const img = this.$refs.img
      if (!img) return

      this.cropper = new Cropper(img, {
        viewMode: 1,
        autoCropArea: 0.8,
        responsive: true,
        background: false,
        zoomOnWheel: false,
        ready: () => {
          const containerData = this.cropper.getContainerData()
          this.cropper.setCropBoxData({
            width: 400,
            height: 100,
            left: (containerData.width - 400) / 2,
            top: (containerData.height - 100) / 2
          })
        }
      })
    },

    binarizeLightBackground (canvas) {
      if (canvas.width === 0 || canvas.height === 0) {
        console.warn('Canvas inválido para binarização')
        return canvas
      }
      const ctx = canvas.getContext('2d')
      const { width, height } = canvas
      const imgData = ctx.getImageData(0, 0, width, height)
      const data = imgData.data

      const hist = new Array(256).fill(0)
      for (let i = 0; i < data.length; i += 4) {
        const lum = Math.round(0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2])
        hist[lum]++
      }
      const total = data.length / 4
      let sum = 0
      for (let i = 0; i < 256; i++) sum += i * hist[i]
      let sumB = 0
      let wB = 0
      let max = 0
      let threshold = 180
      for (let i = 0; i < 256; i++) {
        wB += hist[i]
        if (!wB) continue
        const wF = total - wB
        if (!wF) break
        sumB += i * hist[i]
        const between = wB * wF * ((sumB / wB) - ((sum - sumB) / wF)) ** 2
        if (between > max) { max = between; threshold = i }
      }

      for (let i = 0; i < data.length; i += 4) {
        if (data[i + 3] < 10) continue
        const lum = 0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2]
        if (lum < threshold) {
          data[i] = 0; data[i + 1] = 0; data[i + 2] = 0; data[i + 3] = 255
        } else {
          data[i + 3] = 0
        }
      }

      ctx.putImageData(imgData, 0, 0)
      return canvas
    },

    destroyCropper () {
      if (this.cropper) {
        this.cropper.destroy()
        this.cropper = null
      }
    },

    doCrop () {
      if (!this.cropper) return
      const canvas = this.cropper.getCroppedCanvas({
        imageSmoothingEnabled: true,
        imageSmoothingQuality: 'high'
      })

      this.binarizeLightBackground(canvas)

      this.croppedDataUrl = canvas.toDataURL('image/png')
      this.destroyCropper()
      this.buildFinalImage()
      this.isCropped = true
    },

    removeWhiteBackground (canvas, tolerance = 30) {
      if (canvas.width === 0 || canvas.height === 0) {
        console.warn('Canvas inválido para remover background')
        return canvas
      }
      const ctx = canvas.getContext('2d')
      const { width, height } = canvas
      const imgData = ctx.getImageData(0, 0, width, height)
      const data = imgData.data

      for (let i = 0; i < data.length; i += 4) {
        const r = data[i]
        const g = data[i + 1]
        const b = data[i + 2]

        const whiteness = Math.min(r, g, b)

        if (whiteness >= 255 - tolerance) {
          const alpha = Math.round(((255 - whiteness) / tolerance) * 255)
          data[i + 3] = Math.min(alpha, data[i + 3])
        }
      }

      ctx.putImageData(imgData, 0, 0)
      return canvas
    },

    async buildFinalImage () {
      if (!this.croppedDataUrl) return

      const img = await this.loadImage(this.croppedDataUrl)

      const nome = (this.nomeAssinatura || '').trim().toUpperCase()
      const cargo = (this.cargoAssinatura || '').trim()

      const padTop = 16
      const gapAfterSignature = 10
      const extra = 100
      const lineInset = 18
      const bottomPad = 16

      const lineGapTop = this.modelLineGapTop
      const lineWidth = this.modelLineWidth
      const lineGapBottom = this.modelLineGapBottom
      const nameFontSize = this.modelNameFontSize
      const textGap = this.modelTextGap
      const cargoFontSize = this.modelCargoFontSize

      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')

      canvas.width = img.width + (extra * 2)

      const nameLineH = Math.ceil(nameFontSize * 1.2)
      const cargoLineH = cargo ? Math.ceil(cargoFontSize * 1.2) : 0

      const textBlockH =
        (nome ? nameLineH : 0) +
        (cargo ? (textGap + cargoLineH) : 0)

      const totalH =
        padTop +
        img.height +
        gapAfterSignature +
        lineGapTop +
        lineWidth +
        lineGapBottom +
        textBlockH +
        bottomPad

      canvas.height = totalH

      ctx.fillStyle = '#FFFFFF'
      ctx.fillRect(0, 0, canvas.width, canvas.height)

      let y = padTop
      ctx.drawImage(img, extra, y)
      y += img.height + gapAfterSignature

      y += lineGapTop
      ctx.strokeStyle = '#000000'
      ctx.lineWidth = lineWidth
      ctx.beginPath()
      ctx.moveTo(lineInset, y)
      ctx.lineTo(canvas.width - lineInset, y)
      ctx.stroke()
      y += lineWidth + lineGapBottom

      ctx.textAlign = 'center'
      ctx.fillStyle = '#111111'

      if (nome) {
        ctx.font = `bold ${nameFontSize}px Arial`
        ctx.textBaseline = 'top'
        ctx.fillText(nome, canvas.width / 2, y)
        y += nameLineH
      }

      if (cargo) {
        y += textGap
        ctx.font = `${cargoFontSize}px Arial`
        ctx.fillText(cargo, canvas.width / 2, y)
      }

      this.removeWhiteBackground(canvas, 50)

      const blob = await new Promise((resolve) =>
        canvas.toBlob(resolve, 'image/png', 1.0)
      )

      this.finalBlob = blob
      if (this.finalBlobUrl) URL.revokeObjectURL(this.finalBlobUrl)
      this.finalBlobUrl = URL.createObjectURL(blob)
    },

    dataURLtoBlob (dataurl) {
      const arr = dataurl.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const bstr = atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }

      return new Blob([u8arr], { type: mime })
    },

    async uploadToBackend () {
      const previewBlob = this.dataURLtoBlob(this.croppedDataUrl)
      if (!this.finalBlob || !previewBlob) return

      try {
        const fd = new FormData()
        fd.append('nome', (this.nomeAssinatura || '').trim())
        fd.append('cargo', (this.cargoAssinatura || '').trim())
        fd.append('file', this.finalBlob, `${this.nomeAssinatura.replace(/\s+/g, '_') || 'assinatura'}.png`)
        fd.append('preview', previewBlob, `${this.nomeAssinatura.replace(/\s+/g, '_') || 'assinatura'}_preview.png`)
        fd.append('tamanho_fonte_nome', this.modelNameFontSize)
        fd.append('tamanho_fonte_cargo', this.modelCargoFontSize)
        fd.append('espessura_linha', this.modelLineWidth)
        fd.append('espaco_assinatura_linha', this.modelLineGapTop)
        fd.append('espaco_linha_cargo', this.modelLineGapBottom)
        fd.append('espaco_cargo_nome', this.modelTextGap)

        if (this.isEditing && this.assinaturaEditando.id) {
          fd.append('id', this.assinaturaEditando.id)
        }

        const res = await this.save(fd)

        if (!res.ok) {
          this.$emit('closeModal')
          this.showNotificacao(
            this.$messages.TIPO_SUCCESS,
            this.$messages.TITULO_SUCCESS,
            'Assinatura salva com sucesso!'
          )
        }
      } catch (error) {
        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERRO,
          'Erro ao salvar assinatura!'
        )
        this.$emit('closeModal')
      }
    },

    loadImage (src) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.onload = () => resolve(img)
        img.onerror = reject
        img.src = src
      })
    },

    resetAll () {
      this.destroyCropper()
      this.renderedDataUrl = null
      this.croppedDataUrl = null
      this.finalBlob = null
      if (this.finalBlobUrl) URL.revokeObjectURL(this.finalBlobUrl)
      this.finalBlobUrl = null
      this.isCropped = false
      this.originalDataUrl = null
      this.rotationAngle = 0
    }
  },
  watch: {
    nomeAssinatura (value) {
      this.buildFinalImage()
    },
    cargoAssinatura (value) {
      this.buildFinalImage()
    },
    modelNameFontSize (value) {
      this.buildFinalImage()
    },
    modelCargoFontSize (value) {
      this.buildFinalImage()
    },
    modelLineWidth (value) {
      this.buildFinalImage()
    },
    modelLineGapTop (value) {
      this.buildFinalImage()
    },
    modelLineGapBottom (value) {
      this.buildFinalImage()
    },
    modelTextGap (value) {
      this.buildFinalImage()
    }
  },

  beforeDestroy () {
    this.resetAll()
    window.removeEventListener('paste', this.handlePaste)
  }
}
</script>

<style lang="scss" scoped>
.mt-16 {
  margin-top: 16px;
}

.container-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.mt-24 {
  margin-top: 24px;
}

.btn-group {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.input-row {
  margin-top: 12px;
  margin-bottom: 12px;
  display: flex;
  gap: 8px;
}

.input-col {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.preview-title {
  margin: 16px 0 8px 0;
}

.preview-container {
  margin-top: 26px;
  margin-bottom: 26px;
  flex: 1;
  display: flex;
  justify-content: center;
}

.preview-image {
  max-width: 100%;
  display: block;
  border: 1px dashed #eee;
}

.footer-actions {
  margin-top: 100px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.actions-right {
  display: flex;
  gap: 12px;
  align-items: center;
}

.pdf-image {
  max-width: 100%;
  display: block;
}

.empty-state {
  padding: 24px;
  text-align: center;
  color: #909399;
}

.empty-icon {
  font-size: 32px;
  display: block;
  margin-bottom: 8px;
}

.hidden-input {
  display: none;
}

.preview-title {
  margin-top: 50px;
}

.bt-buscar-arquivo {
  width: 500px;
}
</style>



// WEBPACK FOOTER //
// src/screens/portal/seguranca/components/AppModalAdicionarAssinatura.vue